import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import React, { useEffect, useRef, useState } from "react";
import CustomerList from "../../features/manageCustomers/customerList";
import CustomerTopbar from "../../features/manageCustomers/topbar";
import { Box, Tab, Tabs } from "@mui/material";
import TeamList from "../../features/manageMaintenanceTeam/teamList";
import BookingTopBar from "../../features/manageBookings/bookingTopBar";
import BookingList from "../../features/manageBookings/bookingList";
import { useLazyGetBookingQuery } from "../../services/booking";
import { Booking, VenueType } from "../../types/General";
import { showError } from "../../constants/toasts";
import useAuth from "../../hooks/useAuth";
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const TAB_TYPES = {
  PENDING: 0,
  UPCOMING: 1,
  ONGOING: 2,
  PAST: 3,
  REVIEW: 4,
};

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
const ManageBooking = () => {
  const navigate = useNavigate();
  const [getBookingApi] = useLazyGetBookingQuery();
  const skipLoadingRef = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [bookingData, setBookingData] = useState<Booking[]>([]);
  const [count, setCount] = useState(10);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [valueType, setValueType] = React.useState(0);
  const [country, setCountry] = useState<string>("");
  const user=useAuth()
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    setPage(1);
  };
  const handleChangeType = (event: React.SyntheticEvent, newValue: number) => {
    setValueType(newValue);
    setPage(1);
  };

  const getBookngApi = async () => {
    if (!skipLoadingRef.current) setLoading(true);
    try {
      // For SUB_ADMIN, use accessRoleId.country; for ADMIN, use the selected country
      const countryValue = user?.currentRole === "SUB_ADMIN" 
        ? user?.accessRoleId?.country || "" 
        : country;
        
      const response = await getBookingApi({
        from: page,
        search: debouncedSearchTerm,
        size: 10,
        type: valueType === 0 ? "VENUE" : "STORAGE",
        country: countryValue,
        status:
          valueTabs === TAB_TYPES.PENDING
            ? "pending"
            : valueTabs === TAB_TYPES.ONGOING
            ? "ongoing"
            : valueTabs === TAB_TYPES.UPCOMING
            ? "upcoming"
            : valueTabs === TAB_TYPES.PAST
            ? "past"
            : "review",
      } as any).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBookingData(response?.data?.data);
        setCount(response?.data?.total);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    } finally {
      skipLoadingRef.current = false;
    }
  };

  useEffect(() => {
    getBookngApi();
  }, [valueTabs, page, debouncedSearchTerm, valueType, country, user]);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Booking Requests</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Booking Requests
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Pending" {...a11yProps(0)} />
              <Tab label="Upcoming" {...a11yProps(1)} />
              <Tab label="Ongoing" {...a11yProps(2)} />
              <Tab label="Past" {...a11yProps(3)} />
              {/* <Tab label="Review" {...a11yProps(4)} /> */}
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueType}
              onChange={handleChangeType}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Venue" {...a11yProps(0)} />
              <Tab label="Storage" {...a11yProps(1)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <BookingTopBar
          setDebouncedSearchTerm={setDebouncedSearchTerm}
          country={country}
          onChangeCountry={(val) => {
            setPage(1);
            setCountry(val);
          }}
        />
        <CustomTabPanel value={valueTabs} index={0}>
          <BookingList
            handlePageChange={handlePageChange}
            data={bookingData}
            totalCount={count}
            getVenueOwnerApi={getBookngApi}
            venueStorageType={valueType === 0 ? "Venue" : "Storage"}
            page={page}
            showStatusColumn
          
          />{" "}
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <BookingList
            handlePageChange={handlePageChange}
            data={bookingData}
            totalCount={count}
            getVenueOwnerApi={getBookngApi}
            venueStorageType={valueType === 0 ? "Venue" : "Storage"}
            page={page}
            showStatusColumn={false}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <BookingList
            handlePageChange={handlePageChange}
            data={bookingData}
            totalCount={count}
            getVenueOwnerApi={getBookngApi}
            venueStorageType={valueType === 0 ? "Venue" : "Storage"}
            page={page}
            showStatusColumn={false}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={3}>
          <BookingList
            handlePageChange={handlePageChange}
            data={bookingData}
            totalCount={count}
            getVenueOwnerApi={getBookngApi}
            venueStorageType={valueType === 0 ? "Venue" : "Storage"}
            page={page}
            showStatusColumn={false}
          />
        </CustomTabPanel>
      </div>
    </MainContainer>
  );
};

export default ManageBooking;
